import { RootState } from 'editor/src/store/index';

const getPlugins = (state: RootState) => state.plugins.list;

export default getPlugins;
